import { ContentScriptAction } from '@shared/extension/enums/content-script-action.enum';
import { safeSendChromeMessageToTab } from '@shared/extension/utils/events';
import { isValidTab } from '@shared/extension/utils/tabs';
import { LEARNING_APPS_WITH_CREDENTIALS } from '@shared/utils';
import { getLearningApp } from '@shared/utils/utils/learning-app';

export function initiateThirdPartyAppLogin() {
  chrome.tabs.query({}, function (tabs) {
    tabs.forEach(function (tab) {
      if (!isValidTab(tab)) {
        return;
      }

      const learningApp = getLearningApp(tab.url);
      if (!LEARNING_APPS_WITH_CREDENTIALS.includes(learningApp)) {
        return;
      }
      safeSendChromeMessageToTab(tab.id!, { action: ContentScriptAction.InitiateThirdPartyAppLogin });
    });
  });
}